// LineOfBusinessPage.js
import React, { useState, useEffect } from 'react';
import { 
    Box, TextField, Button, IconButton, Modal,
    Typography, Paper, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
  } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import LockResetIcon from '@mui/icons-material/LockReset';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { Container } from '@mui/material';
import DataTable from 'react-data-table-component';
import { LobService } from '../../services/lobService';
import { toast, ToastContainer } from 'react-toastify';


const LineBusinessPage = () => {
    const [lineOfBusiness, setLineOfBusiness] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [selectedLob, setSelectedLob] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [LobToDelete, setLobToDelete] = useState(null);

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [maxCuotas, setMaxCuotas] = useState('');
    const [siglas, setSiglas] = useState('');
    const [multiLineas, setMultiLineas] = useState('');


    useEffect(() => {
        fetchLineOfBusiness();
      }, []);

    const today = new Date();

    const getStatusText = (idStatus) => {
        return idStatus === 1 ? 'Activo' : 'Inactivo';
    };

    const fetchLineOfBusiness = async () => {
        try {
          setLoading(true);
          const data = await LobService.getAllLineOfBusiness();
          setLineOfBusiness(data);
          setLoading(false);
        } catch (err) {
          setError('Error al cargar los roles');
          setLoading(false);
        }
      };

    const handleSaveLob = async () => {
        var LineOfBusinessDTO = {
            name,
            description,
            maxCuotas,
            siglas,
            multiLineas
          }
          try {
            if (selectedLob) {
              await LobService.editLineOfBusiness(selectedLob.id, LineOfBusinessDTO);
            } else {
              await LobService.createLineOfBusiness(LineOfBusinessDTO);
            }
            setIsModalOpen(false);
            fetchLineOfBusiness();
            toast.success('Servicio guardado con éxito');
          } catch (err) {
            setError('Error al guardar el servicio');
          }
    };

    const handleViewDetail = (lob) => {
        setSelectedLob(lob);
        setIsDetailModalOpen(true);
    };

    const handleEdit = (lob) => {
        setSelectedLob(lob);
        setName(selectedLob.name);
        setDescription(selectedLob.description);
        setMaxCuotas(selectedLob.maxcuotas);
        setSiglas(selectedLob.siglas);
        setMultiLineas(selectedLob.multiLineas);
        setIsModalOpen(true);
    };

    const handleDelete = (lob) => {
      setLobToDelete(lob);
      setIsDeleteDialogOpen(true);
    };

    const handleAdd = () => {
        setSelectedLob(null);
        setName('');
        setDescription('');
        setMaxCuotas('');
        setSiglas('');
        setMultiLineas('');
        setIsModalOpen(true);
    };

    const confirmDelete = async () => {
      await LobService.deleteLineOfBusiness(LobToDelete.id)
      fetchLineOfBusiness();
      setIsDeleteDialogOpen(false);
    };
    

    const columns = [
        {
            name: 'ID',
            selector: row => row.id,
            sortable: true,
        },
        {
            name: 'Nombre',
            selector: row => row.name,
            sortable: true,
            grow: 2,
        },
        {
            name: 'Cuotas Maximas',
            selector: row => row.maxcuotas,
            sortable: true,
        },
        {
            name: 'Siglas',
            selector: row => row.siglas,
            sortable: true,
        },
        {
            name: 'MultiLineas',
            selector: row => row.multiLineas,
            sortable: true,
        },
        {
            name: 'Estado',
            selector: row => getStatusText(row.idStatus),
            sortable: true,
            cell: row => (
            <span className={`apple-badge ${row.idStatus === 1 ? 'apple-badge-success' : 'apple-badge-error'}`}>
                {getStatusText(row.idStatus)}
            </span>
            ),
        },
        {
            name: 'Acciones',
            cell: row => (
            <Box>
                <IconButton onClick={() => handleViewDetail(row)} size="small" className="apple-button apple-tooltip">
                <VisibilityIcon fontSize="small" />
                <span className="tooltiptext">Ver Detalle</span>
                </IconButton>
                <IconButton onClick={() => handleEdit(row)} size="small" className="apple-button apple-tooltip">
                <EditIcon fontSize="small" />
                <span className="tooltiptext">Editar</span>
                </IconButton>
                <IconButton onClick={() => handleDelete(row)} size="small" className="apple-button apple-tooltip">
                <RemoveCircleOutlineIcon fontSize="small" color='error'/>
                <span className="tooltiptext">Desactivar</span>
                </IconButton>
            </Box>
            ),
            width: '200px',
        },
    ];

    const customStyles = {
        table: {
          style: {
            minWidth: '100%',
          },
        },
        headRow: {
          style: {
            backgroundColor: '#F2F2F7',
            borderBottom: 'none',
          },
        },
        headCells: {
          style: {
            fontSize: '12px',
            fontWeight: '600',
            color: '#86868B',
            textTransform: 'uppercase',
          },
        },
        cells: {
          style: {
            fontSize: '14px',
            color: '#1D1D1F',
          },
        },
    };

    const filteredItems = lineOfBusiness.filter(
      item => (item.name && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
              (item.siglas && item.siglas.toLowerCase().includes(filterText.toLowerCase()))
    );

    const subHeaderComponentMemo = React.useMemo(() => {
        return (
          <Box className="apple-card" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', mb: 2 }}>
            <div className="apple-search-container">
              <SearchIcon className="apple-search-icon" />
              <input
                type="text"
                placeholder="Buscar por nombre"
                onChange={e => setFilterText(e.target.value)}
                className="apple-search-input"
              />
            </div>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleAdd}
              className="apple-button"
            >
              Agregar Línea de Negocio
            </Button>
          </Box>
        );
      }, [filterText]);

    return (
        <div className="apple-container">
        <Paper className="apple-card">
        <DataTable
          columns={columns}
          data={filteredItems}
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 20, 30]}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          progressPending={loading}
          persistTableHead
          customStyles={customStyles}
        />
        </Paper>

        <Modal
        open={isDetailModalOpen}
        onClose={() => setIsDetailModalOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        >
            <Box className="apple-modal" sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 600,
            }}>
                <Typography id="modal-modal-title" className="apple-modal-title">
                    Detalles de la Línea de Negocio
                </Typography>
                <div className="apple-modal-content">
                    <TextField
                    label="ID" fullWidth
                    value={selectedLob?.id}
                    margin="normal"
                    InputProps={{readOnly: true,}}
                    />
                    <TextField
                    label="Nombre"
                    fullWidth
                    value={selectedLob?.name}
                    margin="normal"
                    InputProps={{ readOnly: true,}}
                    />
                    <TextField
                    label="Descripción"
                    fullWidth
                    value={selectedLob?.description}
                    margin="normal"
                    InputProps={{readOnly: true,}}
                    />
                    <TextField
                    label="Maxima cantidad de cuotas"
                    fullWidth
                    value={selectedLob?.maxcuotas}
                    margin="normal"
                    InputProps={{readOnly: true,}}
                    />
                    <TextField
                    label="Siglas"
                    fullWidth
                    value={selectedLob?.siglas}
                    margin="normal"
                    InputProps={{readOnly: true,}}
                    />
                    <TextField
                    label="Siglas para multiples líneas"
                    fullWidth
                    value={selectedLob?.multiLineas}
                    margin="normal"
                    InputProps={{readOnly: true,}}
                    />
                    <TextField
                    label="Estado"
                    fullWidth
                    value={getStatusText(selectedLob?.idStatus)}
                    margin="normal"
                    InputProps={{readOnly: true,}}
                    />
                    <TextField
                    label="Fecha de Creación"
                    fullWidth
                    value={new Date(selectedLob?.createAt).toLocaleString()}
                    margin="normal"
                    InputProps={{readOnly: true,}}
                    />

                    </div>
                <div className="apple-modal-footer">
                    <Button onClick={() => setIsDetailModalOpen(false)} className="apple-button">
                    Cerrar
                    </Button>
                </div>
            </Box>
        </Modal>

        <Modal
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box className="apple-modal" sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 600,
            }}>
                <Typography id="modal-modal-title" className="apple-modal-title">
                    {selectedLob ? 'Editar Línea de Negocio' : 'Agregar Nueva Línea de Negocio'}
                </Typography>
                <div className="apple-modal-content">
                    <TextField
                    label="Nombre"
                    variant="outlined"
                    fullWidth
                    className="apple-input"
                    defaultValue={name}
                    onChange={(e) => setName(e.target.value)}
                    />
                    <TextField
                    label="Descripción"
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={4}
                    className="apple-input"
                    defaultValue={description}
                    onChange={(e) => setDescription(e.target.value)}
                    />
                    <TextField
                    label="Maxima cantidad de cuotas"
                    variant="outlined"
                    fullWidth
                    className="apple-input"
                    defaultValue={maxCuotas}
                    onChange={(e) => setMaxCuotas(e.target.value)}
                    />
                    <TextField
                    label="Siglas"
                    variant="outlined"
                    fullWidth
                    className="apple-input"
                    defaultValue={siglas}
                    onChange={(e) => setSiglas(e.target.value)}
                    />
                    <TextField
                    label="Siglas Multiples Líneas"
                    variant="outlined"
                    fullWidth
                    className="apple-input"
                    defaultValue={multiLineas}
                    onChange={(e) => setMultiLineas(e.target.value)}
                    />
                </div>
                <div className="apple-modal-footer">
                    <Button onClick={() => setIsModalOpen(false)} className="apple-button">
                    Cancelar
                    </Button>
                    <Button variant="contained" className="apple-button" onClick={() => handleSaveLob()}>
                    {selectedLob ? 'Guardar Cambios' : 'Crear Línea de Negocio'}
                    </Button>
                </div>
            </Box>
        </Modal>
        {/* Diálogo de confirmación para eliminar */}
      <Dialog
        open={isDeleteDialogOpen}
        onClose={() => setIsDeleteDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ¿Está seguro de que desea eliminar esta Línea de Negocio?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsDeleteDialogOpen(false)} className="apple-button">Cancelar</Button>
          <Button onClick={confirmDelete} className="apple-button" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
      <footer >
        <p>© {today.getFullYear()} Generador de Contratos. Todos los derechos reservados Grupo Defensa. Desarrollado por Gerencia IT </p>
      </footer>
        </div>

    );
};

export default LineBusinessPage;